import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class PickerCheckIcon extends BaseIcon {
    getChildren = () => {
        const color = this.getColor() === 'currentColor' ? '#2e3f58' : this.getColor()

        return [
            <path d="M668.6,373l-4.6-4.7,1.4-1.4,3.2,3.2,7-8.1,1.4,1.4Z" transform="translate(-664 -362)" fill={color} />
        ]
    }
    getViewBox = () => '0 0 13 11'
}
